// Sequência de boot da sessão. Os interceptors (Authorization + Client) precisam
// estar instalados antes de qualquer HTTP: o restoreSession pode disparar o /me de
// reconciliação, que sem eles sai sem token e volta 401.
export function startSession(authStore, { installInterceptors }) {
  installInterceptors()
  // Síncrona: o /me, quando necessário, corre em background e o router não espera
  // por ele (esperar travava a navegação inicial se o interceptor redirecionasse).
  authStore.restoreSession()
}
